import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import {Country} from "../../models/Country";
import {RequestStatus} from "../../utils/Enums";
import {apiClient} from "../../utils/ApiClient";

interface CountriesState {
    countries: Country[];
    getCountriesStatus: RequestStatus;
}

const initialState: CountriesState = {
    countries: [],
    getCountriesStatus: RequestStatus.Idle,
};

export const getCountries = createAsyncThunk('countries/getCountries', async () => {
    const response = await apiClient.get("countries");
    return response.data;
});

const countriesSlice = createSlice({
    name: 'countries',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getCountries.pending, (state, action) => {
                state.getCountriesStatus = RequestStatus.Loading;
            })
            .addCase(getCountries.fulfilled, (state, action) => {
                state.getCountriesStatus = RequestStatus.Success;
                state.countries = action.payload;
            })
            .addCase(getCountries.rejected, (state, action) => {
                state.getCountriesStatus = RequestStatus.Failed;
            });
    },
});

export default countriesSlice.reducer;